module.exports = __webpack_public_path__ + "static/img/slider-77.e522b0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-77.jpg
// module id = M89j
// module chunks = 0